/**
 * Dummy data for Admin module demonstration
 * This will be replaced with real API calls later
 */

export const usersData = [
  {
    id: 1,
    name: "John Doe",
    email: "john.doe@example.com",
    role: "Admin",
    status: "Active",
    lastLogin: "2026-01-28",
    department: "IT",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane.smith@example.com",
    role: "Manager",
    status: "Active",
    lastLogin: "2026-01-29",
    department: "HR",
  },
  {
    id: 3,
    name: "Bob Johnson",
    email: "bob.johnson@example.com",
    role: "User",
    status: "Inactive",
    lastLogin: "2026-01-20",
    department: "Sales",
  },
  {
    id: 4,
    name: "Alice Williams",
    email: "alice.williams@example.com",
    role: "Manager",
    status: "Active",
    lastLogin: "2026-01-29",
    department: "Marketing",
  },
  {
    id: 5,
    name: "Charlie Brown",
    email: "charlie.brown@example.com",
    role: "User",
    status: "Active",
    lastLogin: "2026-01-28",
    department: "IT",
  },
];

export const rolesData = [
  {
    id: 1,
    name: "Admin",
    description: "Full system access",
    permissions: 25,
    users: 3,
    createdDate: "2025-01-01",
  },
  {
    id: 2,
    name: "Manager",
    description: "Department management access",
    permissions: 15,
    users: 8,
    createdDate: "2025-01-01",
  },
  {
    id: 3,
    name: "User",
    description: "Basic user access",
    permissions: 5,
    users: 45,
    createdDate: "2025-01-01",
  },
  {
    id: 4,
    name: "Guest",
    description: "Limited read-only access",
    permissions: 2,
    users: 12,
    createdDate: "2025-06-15",
  },
];

export const permissionsData = [
  {
    id: 1,
    name: "user.create",
    module: "Users",
    description: "Create new users",
    category: "Write",
  },
  {
    id: 2,
    name: "user.edit",
    module: "Users",
    description: "Edit existing users",
    category: "Write",
  },
  {
    id: 3,
    name: "user.delete",
    module: "Users",
    description: "Delete users",
    category: "Delete",
  },
  {
    id: 4,
    name: "user.view",
    module: "Users",
    description: "View user details",
    category: "Read",
  },
  {
    id: 5,
    name: "role.manage",
    module: "Roles",
    description: "Manage roles and permissions",
    category: "Admin",
  },
  {
    id: 6,
    name: "settings.manage",
    module: "Settings",
    description: "Manage system settings",
    category: "Admin",
  },
];

export const partnersData = [
  {
    id: 1,
    name: "IT Department",
    manager: "John Doe",
    employees: 12,
    budget: "$250,000",
    location: "Building A, Floor 3",
  },
  {
    id: 2,
    name: "HR Department",
    manager: "Jane Smith",
    employees: 8,
    budget: "$180,000",
    location: "Building B, Floor 2",
  },
  {
    id: 3,
    name: "Sales Department",
    manager: "Mike Wilson",
    employees: 25,
    budget: "$500,000",
    location: "Building A, Floor 1",
  },
  {
    id: 4,
    name: "Marketing Department",
    manager: "Alice Williams",
    employees: 15,
    budget: "$320,000",
    location: "Building B, Floor 3",
  },
];

export const activityLogsData = [
  {
    id: 1,
    user: "John Doe",
    action: "Login",
    description: "User logged in successfully",
    timestamp: "2026-01-29 09:15:23",
    ipAddress: "192.168.1.100",
  },
  {
    id: 2,
    user: "Jane Smith",
    action: "Update",
    description: "Updated user profile",
    timestamp: "2026-01-29 09:30:45",
    ipAddress: "192.168.1.101",
  },
  {
    id: 3,
    user: "Bob Johnson",
    action: "Delete",
    description: "Deleted department record",
    timestamp: "2026-01-29 10:05:12",
    ipAddress: "192.168.1.102",
  },
  {
    id: 4,
    user: "Alice Williams",
    action: "Create",
    description: "Created new role 'Supervisor'",
    timestamp: "2026-01-29 10:30:00",
    ipAddress: "192.168.1.103",
  },
  {
    id: 5,
    user: "Charlie Brown",
    action: "View",
    description: "Accessed reports dashboard",
    timestamp: "2026-01-29 11:00:15",
    ipAddress: "192.168.1.104",
  },
];
